export default __webpack_public_path__ + "static/media/SupplierIcon.c9c69a6f.svg";